import { FieldError } from 'react-hook-form';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RadioGroup } from 'enova-frontend-components';

import { OppvarmingBruk } from '../../../../../utils/registerEnums';

import { EnumRadioButton } from './enumRadioButton';

interface Props {
  onChange: (value: OppvarmingBruk) => void;
  error?: FieldError;
  value?: OppvarmingBruk;
}

export const OppvarmingBrukRadio: FC<Props> = ({ onChange, error, value }) => {
  const { t } = useTranslation();

  return (
    <RadioGroup
      row
      marginBottom
      error={!!error}
      value={value ?? null}
      label={t(`register.tekniskUtstyr.kjel.bruk.label`)}
      helperText={error && t(`${error.message}`)}
      onChange={(_, value) => onChange(value as OppvarmingBruk)}
    >
      <EnumRadioButton i18nPrefix="register" value={OppvarmingBruk.TappevannOgOppvarming} />
      <EnumRadioButton i18nPrefix="register" value={OppvarmingBruk.Tappevann} />
      <EnumRadioButton i18nPrefix="register" value={OppvarmingBruk.Oppvarming} />
      <EnumRadioButton i18nPrefix="register" value={OppvarmingBruk.Ukjent} />
    </RadioGroup>
  );
};
